export default {
    format(price = 0) {
        return parseFloat(price).toLocaleString('ru-RU', {style: 'currency', currency: 'RUB', minimumFractionDigits: 2}).replace(/,+/g, '.').replace(/\s+/g, ',').replace(',₽', '');
    }
}


// WEBPACK FOOTER //
// ./src/helpers/price/index.js